export const getClassifications = (translate: (text: string) => string) => {
  const classifications = [
    { symbol: 'MOBILE_PHONE' as const, label: translate('Mobile phone') },
    { symbol: 'MOBILE_PHONE_ACCESSORY' as const, label: translate('Mobile phone accessory') },
    { symbol: 'PC' as const, label: translate('PC') },
    { symbol: 'PC_ACCESSORY' as const, label: translate('PC accessory') },
    { symbol: 'MONITOR' as const, label: translate('Monitor') },
    { symbol: 'TABLET' as const, label: translate('Tablet') },
    { symbol: 'SOFTWARE' as const, label: translate('Software') },
    {
      symbol: 'HOME_OFFICE' as const,
      label: translate('Home office'),
    },
    // Commenting out as it leads to incorrect calculation of limit in some cases
    // { symbol: 'ALL' as const, label: translate('All products') },
  ]

  return classifications
}
